import React, { useContext } from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import RegionSelect from "../RegionSelect"
import { RegionContext } from "@/context/region"

const FooterSecondary = ({ footerLinksHidden }) => {
  const { t } = useTranslation()

  const { region } = useContext(RegionContext)

  const currentYear = new Date().getFullYear()

  return (
    <footer className="container-fluid pb-5">
      <div className="row col-xs">
        <div
          className="
              footer-secondary
              col-xs-12 col-sm-10 col-sm-offset-1 col-md-12 col-md-offset-0"
        >
          {region !== "LA" && <RegionSelect />}

          <span className="p--xs mt-4">
            {t("footer.copyright", { currentYear })}
          </span>
          {footerLinksHidden && (
            <span className="flex">
              <p className="mb-0 p--xs mt-4 pr-2">
                <Link to="/terms">{t("footer.links.column-two.terms")}</Link>
              </p>
              <p className="p--xs mt-4">
                <Link to="/privacy">
                  {t("footer.links.column-two.privacy")}
                </Link>
              </p>
            </span>
          )}
        </div>
      </div>
    </footer>
  )
}

export default FooterSecondary
